import React 		from 'react';
import ReactDOM from 'react-dom';

import BLComponent from '../core/_BLComponent.jsx';

export default class Changelog extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section className="api-method-landing">
				<h1 className="text--xxl-title l-margin-bottom--xl">API Changelog</h1>
				<p>Changes to the API will be posted here.</p>
				<section>
					<h2>February 2022</h2>
					<h4>Added:</h4>
					<ul>
						<li>
							<a href="?page=get-order">Get Order</a> call can now return an additional <a href="?page=resource-representations-order">order resource</a>:
							<ul>
								<li>shipping.address.phone_number</li>
							</ul>
						</li>
					</ul>
					<h4>Fixed:</h4>
					<ul>
						<li>
							Bug fixes in <a href="?page=update-order">Update Order</a> call:
							<ul>
								<li>Fixed the INTERNAL_SERVER_ERROR caused by adding the buyer's phone number to the <a href="?page=resource-representations-order">order resource</a></li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>October 2021</h2>
					<h4>Fixed:</h4>
					<ul>
						<li>
							Bug fixes in <a href="?page=get-notifications">Get Notifications</a> call:
							<ul>
								<li>Read notifications were being returned as unread</li>
								<li>If a callback URL was not set, an empty list of notifications was always returned</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>April 2015 - September 2021</h2>
					<p className="text--note">Note: We are actively recovering descriptions of changes made during this timeframe.</p>
				</section>
				<section>
					<h2>March 2015</h2>
					<h4>Modified:</h4>
					<ul>
						<li>
							<a href="?page=get-inventories">Get Inventories</a> and <a href="?page=get-inventory">Get Inventory</a> calls can now return an additional <a href="?page=resource-representations-inventory">store inventory resource</a>:
							<ul>
								<li>stock_room_id</li>
							</ul>
						</li>
						<li>
							<a href="?page=create-inventory">Create Inventory</a> call now allows inventory consolidation.
						</li>
					</ul>
					<h4>Fixed:</h4>
					<ul>
						<li>
							Bug fixes in <a href="?page=update-coupon">Update Coupon</a> call:
							<ul>
								<li>"discount_amount" and "applies_to" values were not set correctly</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>February 2015</h2>
					<h4>Added:</h4>
					<ul>
						<li>
							Added following property to <a href="?page=resource-representations-inventory">Store Inventory resource</a>:
							<ul>
								<li>my_weight: Custom weight of items</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>December 2014</h2>
					<h4>Added:</h4>
					<ul>
						<li>
							Added following properties to <a href="?page=resource-representations-inventory">Store Inventory resource</a>:
							<ul>
								<li>sale_rate: <a href="http://www.bricklink.com/help.asp?helpID=46">Sale</a> value to adjust item price</li>
								<li>Parameters for <a href="http://www.bricklink.com/help.asp?helpID=131">Tiered Pricing</a></li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>October 2014</h2>
					<h4>Added:</h4>
					<ul>
						<li>
							Added following property to <a href="?page=resource-representations-inventory">Store Inventory resource</a>:
							<ul>
								<li>my_cost: <a href="http://www.bricklink.com/help.asp?helpID=1109">My Cost</a> value to tracking the cost of item</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>July 2014</h2>
					<h4>Fixed:</h4>
					<ul>
						<li>
							Fixed typo in the word "quantity" inside <a href="?page=resource-representations-catalog">price detail</a>.
							<ul>
								<li>For next several update, both "quantity" and "qunatity" will be returned</li>
								<li>Then a field "qunatity" will be removed later</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>June 2014</h2>
					<h4>Fixed:</h4>
					<ul>
						<li>Fixed bug in creating an inventory that does not allows item in color "0 (Not Applicable)"</li>
						<li>
							Fixed error in <a href="?page=update-inventory">Update Inventory</a> resource document
							<ul>
								<li>color_id can not be updated</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>May 2014</h2>
					<h4>Added:</h4>
					<ul>
						<li>
							Added following properties to <a href="?page=resource-representations-order">Order resource</a>:
							<ul>
								<li>cost.vat_rate(disp_cost.vat_rate): VAT percentage applied to this order</li>
								<li>cost.vat_amount(disp_cost.vat_amount): Total amount of VAT included in the grand_total price</li>
							</ul>
						</li>
					</ul>
					<h4>Fixed:</h4>
					<ul>
						<li>Fixed bug in getting an order that does not retrieves PURGED orders</li>
					</ul>
				</section>
				<section>
					<h2>April 2014</h2>
					<h4>Modified:</h4>
					<ul>
						<li>
							Modified <a href="?page=update-order">Update Order</a> calls now allows:
							<ul>
								<li>to update order remarks</li>
							</ul>
						</li>
						<li>
							Modified <a href="?page=get-price-guide">Get Price Guide</a> calls now allows:
							<ul>
								<li>to include or exclude VAT</li>
							</ul>
						</li>
					</ul>
					<h4>Added:</h4>
					<ul>
						<li>
							Added following properties to <a href="?page=resource-representations-order">Order resource</a>:
							<ul>
								<li>buyer_order_count: Total count of all orders placed by the buyer in the seller's store(includes the order just placed and also purged orders)</li>
							</ul>
						</li>
						<li>
							Added normalized address and name field to <a href="?page=resource-representations-order">Order resource</a>
							<ul>
								<li>If a buyer updated his/her address and name as a normalized form</li>
							</ul>
						</li>
						<li>
							Added new endpoint to get mappings of BL Catalog Item to Part-Color-Code(A.K.A ElementID)
							<ul>
								<li>See: <a href="?page=method-mapping">Item Mapping Method</a></li>
							</ul>
						</li>
						<li>
							Added following methods:
							<ul>
								<li><a href="?page=get-known-colors">Get Known Colors</a>: Gets currently known colors of the item</li>
								<li><a href="?page=send-drive-thru">Send Drive Thru</a>: Send "Thank You, Drive Thru!" e-mail to a buyer</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>February 28, 2014</h2>
					<h4>Modified:</h4>
					<ul>
						<li>
							Modified following properties of <a href="?page=resource-representations-order">Order resource</a>:
							<ul>
								<li>cost.disp_currency_code -> disp_cost.currency_code</li>
								<li>cost.disp_subtotal -> disp_cost.subtotal</li>
								<li>cost.disp_grand_total -> disp_cost.grand_total</li>
							</ul>
						</li>
						<li>
							Modified <a href="?page=update-order">Update Order</a> calls now allows:
							<ul>
								<li>to update file/unfiled status</li>
								<li>to update shipping method ID</li>
							</ul>
						</li>
					</ul>
					<h4>Added:</h4>
					<ul>
						<li>
							Added following properties to <a href="?page=resource-representations-order">Order resource</a>:
							<ul>
								<li>date_status_changed: The time the order status was last modified</li>
								<li><strike>buyer_order_count: Total count of all orders placed by the buyer in the seller's store(includes the order just placed and also purged orders)</strike> -> to be included in next release</li>
								<li>is_filed: Indicates whether the order is filed</li>
								<li>sent_drive_thru: Indicates whether "Thank You, Drive Thru!" email has been sent</li>
								<li>total_weight: The total weight of the items ordered based on catalog and custom weight</li>
								<li>shipping.method_id: Shipping method ID</li>
								<li>disp_cost: Cost information for this order in DISPLAY currency</li>
							</ul>
						</li>
						<li>
							Added following properties to <a href="?page=order-item">Order Item</a> resource:
							<ul>
								<li>color_name: Color name of the item</li>
								<li>weight: The weight of the item that overrides the catalog weight</li>
							</ul>
						</li>
						<li>
							Added new endpoint for creating/reading/updating/deleting Coupons
							<ul>
								<li>See: <a href="?page=method-coupon">Coupon Method</a></li>
							</ul>
						</li>
						<li>
							Added new endpoint for creating/reading/updating/deleting your Notes on Members
							<ul>
								<li>See: <a href="?page=method-member">Member Method</a></li>
							</ul>
						</li>
						<li>
							Added new endpoint for reading Feedback Ratings of a specific member
							<ul>
								<li>See: <a href="?page=method-member">Member Method</a></li>
							</ul>
						</li>
						<li>
							Added new endpoint for reading Shipping Methods of your store
							<ul>
								<li>See: <a href="?page=method-setting">Setting Method</a></li>
							</ul>
						</li>
						<li>
							Added following methods:
							<ul>
								<li><a href="?page=update-payment-status">Update Payment Status</a>: Updates the payment status of a specific order</li>
								<li><a href="?page=get-item-image">Get Item Image</a>: Gets image URL of the specified item by colors</li>
							</ul>
						</li>
					</ul>
					<h4>Fixed:</h4>
					<ul>
						<li>Fixed bug in Push Notifications that are not delivered properly</li>
					</ul>
				</section>
				<section>
					<h2>February 06, 2014</h2>
					<h4>Fixed:</h4>
					<ul>
						<li>
							Fixed typo in <a href="?page=resource-representations-order">Order resource</a> document
							<ul>
								<li>cost.grandtotal -> cost.grand_total</li>
								<li>cost.disp_grandtotal -> cost.disp_grand_total</li>
							</ul>
						</li>
					</ul>
				</section>
				<section>
					<h2>February 03, 2014</h2>
					<h4>Modified:</h4>
					<ul>
						<li>
							Modified the response data to be filtered based on attributes of the resources
							<ul>
								<li>Order: status</li>
								<li>Inventory: status, item type, categories, colors</li>
								<li>Price guide: seller locations</li>
							</ul>
						</li>
					</ul>
					<h4>Added:</h4>
					<ul>
						<li>
							Added following properties to <a href="?page=resource-representations-order">Order resource</a>:
							<ul>
								<li>cost.disp_currency_code: The display currency code of the user</li>
								<li>cost.disp_subtotal: The subtotal price in display currency of the user</li>
								<li>cost.disp_grandtotal: The grand total price in display currency of the user</li>
							</ul>
						</li>
						<li>
							Added following properties to <a href="?page=order-item">Order Item</a> resource:
							<ul>
								<li>inventory_id: The ID of the inventory that includes the item</li>
								<li>currency_code: The currency code of the price</li>
								<li>disp_currency_code: The display currency code of the user</li>
								<li>disp_unit_price: The original price of this item per sale unit in display currency of the user</li>
								<li>disp_unit_price_final: The unit price of this item after applying tiered pricing policy in display currency of the user</li>
								<li>remarks: User remarks of the order item</li>
								<li>description: User description of the order item</li>
							</ul>
						</li>
						<li>Added individual sales/history information to <a href="?page=get-price-guide">Price Guide</a> resource</li>
						<li>Added a sample request URI of each API calls(with optional parameters) to document</li>
					</ul>
					<h4>Fixed:</h4>
					<ul>
						<li>Fixed bug in updating order status that are not able to update status to "SHIPPED"</li>
					</ul>
				</section>
			</section>
		);
	}
}